import { registerBuilderAccordion } from "./__internal__/registerBuilderAccordion";
import { registerBuilderButton } from "./__internal__/registerBuilderButton";
import { registerBuilderDottedTooltip } from "./__internal__/registerBuilderDottedTooltip";
import { registerBuilderFoundationIcon } from "./__internal__/registerBuilderFoundationIcon";
import { registerBuilderLayout } from "./__internal__/registerBuilderLayout";
import { registerBuilderRow } from "./__internal__/registerBuilderRow";
import { registerBuilderTypography } from "./__internal__/registerBuilderTypography";
export var registerBuilderComponents = function() {
    registerBuilderAccordion();
    registerBuilderButton();
    registerBuilderFoundationIcon();
    registerBuilderLayout();
    registerBuilderRow();
    registerBuilderTypography();
    registerBuilderDottedTooltip();
};
